import type { LayoutLoad } from './$types';

export const load: LayoutLoad = async () => {
  return {
    breadcrumbs: [{ title: 'Storage Configuration', url: '/storage-config' }],
  };
};
